import { GenericBlankState, Pane } from "components/ui"
import { useContext } from "react"
import RegisterableContext from "components/admin/registerable/context"
import SelectionAttendees from "./SelectionAttendees"

const Attendees = () => {
  const { registerable } = useContext(RegisterableContext)
  const { attendeeTypeSelections } = registerable

  return (
    <Pane marginBottom={2}>
      <Pane.Header>
        <Pane.Title>Attendees</Pane.Title>
      </Pane.Header>
      <Pane.Body axis="vertical" gap={2}>
        {attendeeTypeSelections.some(({ count }) => count > 0) ? (
          attendeeTypeSelections.map(selection => (
            <SelectionAttendees key={selection.id} id={selection.id} />
          ))
        ) : (
          <GenericBlankState message="To get started, make selections above" />
        )}
      </Pane.Body>
    </Pane>
  )
}

export default Attendees
